import { isAfter } from 'date-fns';
import sortBy from 'lodash.sortby';
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { REGISTERED_EVENTS_QUERY } from '@general/graphql/event.graph';

const useRegisteredEvents = (futureOnly = true) => {
    const [registeredEvents, setRegisteredEvents] = useState(null);
    const { data, ...rest } = useQuery(REGISTERED_EVENTS_QUERY);

    useEffect(() => {
        if (!data?.viewerEvents) {
            return;
        }

        let events = data.viewerEvents.filter(event => !!event);

        if (futureOnly) {
            events = events.filter(event => {
                const endTime = new Date(event.endsAt);
                // ICSC considers an event ended on midnight of the next day after it ends, only so users can still explore it after the event for networking
                endTime.setHours(24, 0, 0, 0);
                const now = new Date();

                return !isAfter(now, endTime);
            });
        }

        setRegisteredEvents(sortBy(events, 'endsAt'));
    }, [data, futureOnly]);

    return { registeredEvents, ...rest };
};

export default useRegisteredEvents;
